import React, { Component } from "react";
import "./EmployeeTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faEdit,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Button } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

class AdminEmployeeTable extends Component {
  state = {
    employeeData: [],
    loading: true,

    columnDefs: [
      {
        headerName: "Edit",
        field: "edit",
        filter: false,
        width: 50,
        cellRendererFramework: this.renderEditButton.bind(this),
      },
      {
        headerName: "Employee Code",
        field: "EmployeeCode",

        sortable: true,
        width: 100,
        // filter: true ,
      },
      {
        headerName: "Email",
        field: "Email",
        sortable: true,

        // filter: true ,
        width: 150,
      },
      {
        headerName: "Account Access",
        field: "Account",
        sortable: true,

        // width: 70,
        // filter: true ,
      },
      {
        headerName: "First Name",
        field: "FirstName",
        sortable: true,
        width: 110,

        // filter: true ,
      },
      {
        headerName: "Last Name",
        field: "LastName",
        sortable: true,
        width: 110,

        // filter: true ,
      },
      {
        headerName: "DOB",
        field: "DOB",
        sortable: true,
        filter: true,
      },
      {
        headerName: "ContactNo",
        field: "ContactNo",
        sortable: true,
        width: 117,
        // filter: true ,
      },

      {
        headerName: "Role",
        field: "RoleName",
        sortable: true,

        width: 70,
        // filter: true ,
      },
      {
        headerName: "Position Name",
        field: "PositionName",
        sortable: true,
        width: 120,

        // filter: true ,
      },
      {
        headerName: "Department Name",
        field: "DepartmentName",
        sortable: true,
        width: 120,
        // filter: true ,
      },

      {
        headerName: "Date Of Joining",
        field: "DateOfJoining",
        sortable: true,
        width: 120,
        // filter: true ,
      },
      {
        headerName: "Details",
        field: "info",

        filter: false,
        width: 70,
        cellRendererFramework: this.renderInfoButton.bind(this),
      },
      {
        headerName: "",
        field: "delete",
        filter: false,
        width: 30,
        // cellRenderer:this.ageCellRendererFunc,
        // cellRendererFramework: function(params) {
        //   return <button OnClick={console.log("pa",params)}>Test</button>;
        // },
        cellRendererFramework: this.renderButton.bind(this),
      },
    ],
    rowData: [],
    defaultColDef: {
      resizable: true,
      width: 100,
      filter: "agTextColumnFilter",
      // filter: true ,
    },
    getRowHeight: function (params) {
      return 35;
    },
  };
  employeeObj = [];
  rowDataT = [];

  loadEmployeeData = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/employee", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then(async (response) => {
        this.employeeObj = response.data.reverse();

        this.setState({ employeeData: response.data });
        this.setState({ loading: false });
        this.rowDataT = [];
        await this.employeeObj.map((data) => {
          // console.log(JSON.stringify(data))
          let temp = {
            data,
            Email: data["Email"] || "-",
            Password: data["Password"] || "-",
            Account:
              data.Account[0] === "admin"
                ? "Admin"
                : data.Account[0] === "hr"
                ? "HR"
                : data.Account[0] === "emp"
                ? "Employee"
                : data.Account[0] === "chairman"
                ? "Chairman"
                : data.Account[0] === "ceo"
                ? "CEO"
                : data.Account[0] === "cfo"
                ? "CFO"
                : data.Account[0] === "hod"
                ? "HOD"
                : "-",
            RoleName: data.role[0] ? data.role[0].RoleName : "-",
            FirstName: data["FirstName"] || "-",
            LastName: data["LastName"] || "-",
            DOB: data["DOB"].slice(0, 50) || "-",
            ContactNo: data["ContactNo"] || "-",
            EmployeeCode: data["EmployeeCode"] || "-",
            DepartmentName: data.department[0]
              ? data.department[0].DepartmentName
              : "-",
            PositionName: data.position[0]
              ? data.position[0].PositionName
              : "-",
            DateOfJoining: data["DateOfJoining"].slice(0, 50) || "-",
          };

          this.rowDataT.push(temp);
        });
        this.setState({ rowData: this.rowDataT });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onEmployeeDelete = (e) => {
    // console.log(e);
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/employee/" +
            e,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            alert(res.data.message);
          }
          this.componentDidMount();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  componentDidMount() {
    this.loadEmployeeData();
  }
  handleClick = (e) => {
    // console.log(e);
  };
  renderInfoButton(params) {
    // // console.log(params);
    return (
      <div>
        <FontAwesomeIcon
          icon={faInfoCircle}
          onClick={() => this.props.onEmpInfo(params.data.data)}
        />
      </div>
    );
  }
  renderButton(params) {
    return (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => this.onEmployeeDelete(params.data.data["_id"])}
      />
    );
  }
  renderEditButton(params) {
    return (
      <FontAwesomeIcon
        icon={faEdit}
        onClick={() => this.props.onEditEmployee(params.data.data)}
      />
    );
  }

  searchChange = (e) => {
    // console.log(e.target.value);
    this.setState({ searchData: e.target.value });
  };

  render() {
    // let filteredEmp = this.getFilteredEmp();
    return (
      <div id="table-outer-div-scroll">
        <h2 id="role-title">Employee Details</h2>

        <Button
          variant="primary"
          id="add-button"
          onClick={this.props.onAddEmployee}>
          <FontAwesomeIcon icon={faPlus} id="plus-icon" />
          Add
        </Button>

        <div id="clear-both" />
        {!this.state.loading ? (
          <div
            id="table-div"
            className="ag-theme-balham"
            //   style={
            //     {
            //     height: "500px",
            //     width: "100%"
            //   }
            // }
          >
            <AgGridReact
              columnDefs={this.state.columnDefs}
              defaultColDef={this.state.defaultColDef}
              rowData={this.state.rowData}
              // floatingFilter={true}
              // onGridReady={this.onGridReady}
              pagination={true}
              paginationPageSize={20}
              getRowHeight={this.state.getRowHeight}
            />
          </div>
        ) : (
          <div id="loading-bar">
            <RingLoader
              css={override}
              sizeUnit={"px"}
              size={50}
              color={"#0000ff"}
              loading={true}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AdminEmployeeTable;
